//#region src/types.ts
/**
* Enum für mögliche Statuswerte im SubmitDialog.
*/
var PdSubmitDialogStatus = /* @__PURE__ */ function(PdSubmitDialogStatus) {
	PdSubmitDialogStatus[PdSubmitDialogStatus["SEND"] = 1] = "SEND";
	PdSubmitDialogStatus[PdSubmitDialogStatus["SUCCESS"] = 2] = "SUCCESS";
	PdSubmitDialogStatus[PdSubmitDialogStatus["FAILED"] = 3] = "FAILED";
	return PdSubmitDialogStatus;
}({});
//#endregion
export { PdSubmitDialogStatus };
